'use strict';

var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');

var _require = require('next/app'),
  NextApp = _require.default;

var React = require('react');

var ServerContextContext = require('./ServerContextContext');

module.exports = function withServerContext(Component) {
  var WithServerContext = function WithServerContext(_ref) {
    var serverContext = _ref.serverContext,
      props = _objectWithoutPropertiesLoose(_ref, ['serverContext']);

    return React.createElement(
      ServerContextContext.Provider,
      {
        value: serverContext,
      },
      React.createElement(Component, props)
    );
  };

  if (typeof process === 'object' && process.env.NODE_ENV !== 'production')
    WithServerContext.displayName =
      'withServerContext(' +
      (Component.displayName || Component.name || 'Component') +
      ')';

  WithServerContext.getInitialProps = function (context) {
    try {
      function _temp3(_Component$getInitial) {
        function _temp(props) {
          if (req)
            props.serverContext = {
              request: req,
              response: res,
              toJSON: function toJSON() {
                return undefined;
              },
            };
          return props;
        }

        return _Component$getInitial3 || !isApp
          ? _temp(
              _Component$getInitial3
                ? _Component$getInitial
                : isApp
                ? NextApp.getInitialProps(context)
                : {}
            )
          : Promise.resolve(
              _Component$getInitial3
                ? _Component$getInitial
                : isApp
                ? NextApp.getInitialProps(context)
                : {}
            ).then(_temp);
      }

      var isApp = 'ctx' in context;

      var _ref2 = isApp ? context.ctx : context,
        req = _ref2.req,
        res = _ref2.res;

      var _Component$getInitial3 = Component.getInitialProps;
      return Promise.resolve(
        _Component$getInitial3
          ? Promise.resolve(Component.getInitialProps(context)).then(_temp3)
          : _temp3(0)
      );
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return WithServerContext;
};
